import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import NavBar from "../NavBar/NavBar.tsx";
import Help from "../Help Section/Help";
import Footer from "../Footer/Footer.tsx";
import ScrollToTopButton from "./ScrollToTopButton.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body)

   Shared building blocks for every service page so they all match ServicePage. */

/* ---------- icons (24x24 stroke icons) ---------- */
export const ICONS = {
  code: <path d="M8 8l-5 4 5 4M16 8l5 4-5 4M14 5l-4 14" />,
  cart: <><circle cx="9" cy="20" r="1.5" /><circle cx="18" cy="20" r="1.5" /><path d="M2 3h3l2.5 12h11l2-8H6" /></>,
  mobile: <><rect x="7" y="2" width="10" height="20" rx="2.5" /><path d="M11 18h2" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>,
  megaphone: <><path d="M3 11v3l12 5V6L3 11z" /><path d="M7 15l1 5h3M19 9a4 4 0 010 6" /></>,
  shield: <><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" /></>,
  chart: <path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6" />,
  trend: <path d="M3 17l6-6 4 4 8-8M15 7h6v6" />,
  users: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0113 0M16 4.5a3.5 3.5 0 010 7M18 14.5a6.5 6.5 0 013.5 5.5" /></>,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></>,
  server: <><rect x="3" y="4" width="18" height="6" rx="2" /><rect x="3" y="14" width="18" height="6" rx="2" /><path d="M7 7h.01M7 17h.01" /></>,
  database: <><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></>,
  tag: <><path d="M3 12V4h8l10 10-8 8L3 12z" /><circle cx="7.5" cy="8.5" r="1" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="M21 16l-5-5-8 9" /></>,
  doc: <><path d="M6 3h9l4 4v14H6z" /><path d="M14 3v5h5M9 13h7M9 17h5" /></>,
  smile: <><circle cx="12" cy="12" r="9" /><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" /></>,
  survey: <><path d="M5 4h14v16H5z" /><path d="M9 9h6M9 13h6M9 17h3" /></>,
  book: <><path d="M4 5a2 2 0 012-2h13v16H6a2 2 0 00-2 2V5z" /><path d="M8 7h7" /></>,
  pen: <path d="M4 20l1-5L16 4l4 4L9 19l-5 1z" />,
  eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  cpu: <><rect x="6" y="6" width="12" height="12" rx="2" /><path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" /></>,
  bolt: <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />,
  layers: <><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5" /></>,
  palette: <><path d="M12 3a9 9 0 100 18c1.5 0 2-1 1.5-2s0-2 1.5-2h2a3 3 0 003-3c0-6-4-11-8-11z" /><path d="M7.5 11h.01M10 7h.01M15 8h.01" /></>,
  rocket: <><path d="M5 19c0-3 1-4 3-4l-1-3c3-6 8-8 13-8 0 5-2 10-8 13l-3-1c0 2-1 3-4 3z" /><circle cx="15" cy="9" r="1.5" /></>,
  monitor: <><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></>,
  bug: <><rect x="8" y="8" width="8" height="12" rx="4" /><path d="M12 8V5M5 12h3M16 12h3M5 18l3-2M19 18l-3-2M8 6l2 2M16 6l-2 2" /></>,
};

/* ---------- styles ---------- */
export const SERVICE_STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.sv{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.sv-in{display:flex;align-items:center;justify-content:space-between;gap:70px;max-width:1240px;margin:0 auto}
.sv-in.rev{flex-direction:row-reverse}
.sv-sec{position:relative;padding:76px 24px}
.sv-sec>*{position:relative;z-index:1}
.sv-sec.tint{background:linear-gradient(180deg,#f4fafd,#e8f3f9);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.sv-sec.tint::before,.sv-sec.tint::after{content:"";position:absolute;z-index:0;border-radius:50%;pointer-events:none}
.sv-sec.tint::before{width:380px;height:380px;right:-140px;top:-160px;background:radial-gradient(circle,rgba(37,150,190,.14),transparent 68%)}
.sv-sec.tint::after{width:300px;height:300px;left:-120px;bottom:-140px;background:radial-gradient(circle,rgba(69,115,166,.13),transparent 68%)}
.sv-center{text-align:center;max-width:880px;margin:0 auto}

.sv-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase;box-shadow:0 6px 16px -10px rgba(69,115,166,.6)}
.sv-chip::before{content:"";display:inline-block;width:7px;height:7px;margin-right:9px;border-radius:50%;vertical-align:1px;background:linear-gradient(135deg,var(--head),var(--btn))}
.sv-sec.tint .sv-chip{background:#fff}
.sv h1,.sv h2{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s}
.sv h2:hover{color:var(--btn)}
.sv-hero h1{font-size:40px;background:linear-gradient(90deg,var(--head) 20%,var(--btn));-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}
.sv-sec h2{font-size:34px}
.sv h3.sv-sub{margin:0 0 18px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.sv-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.sv-center .sv-line{justify-content:center}
.sv-line i{display:block;height:3px;width:46px;border-radius:3px;background:var(--btn)}.sv-line i:last-child{width:16px;background:var(--head)}
.sv p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}
.sv p b{font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head)}
.sv-text{position:relative;flex:1;min-width:0;max-width:580px}
.sv-num{position:absolute;z-index:-1;top:-46px;right:0;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:130px;line-height:1;
  color:transparent;-webkit-text-stroke:2px #c9dfeb;pointer-events:none;user-select:none}

.rv{opacity:0;transform:translateY(46px);transition:opacity .8s cubic-bezier(.2,.8,.2,1),transform .8s cubic-bezier(.2,.8,.2,1);transition-delay:var(--d,0s)}
.rv.in{opacity:1;transform:none}

.sv-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;box-shadow:0 0 0 1px var(--line) inset;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.sv-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.sv-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.sv-btn:hover::before{transform:none}
.sv-btn span{display:inline-block;transition:transform .35s}
.sv-btn:hover span{transform:translateX(5px)}
.sv-btn:focus-visible,.sv-tag:focus-visible{outline:3px solid rgba(37,150,190,.45);outline-offset:3px}
.sv-btn.primary{background:linear-gradient(90deg,var(--head),var(--btn));color:#fff;box-shadow:0 16px 28px -14px rgba(37,150,190,.9)}
.sv-btn.primary::before{background:linear-gradient(90deg,var(--btn),var(--head))}
.sv-center .sv-btn{margin-top:8px}

.sv-tags{display:flex;flex-wrap:wrap;gap:10px;margin:22px 0 30px}
.sv-center .sv-tags{justify-content:center;margin:8px 0 0}
.sv-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.sv-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.sv-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.sv-tag:hover::before{transform:none}

/* hero */
.sv-hero{position:relative;isolation:isolate;padding:150px 24px 90px;
  background:radial-gradient(900px 480px at 88% 8%,rgba(37,150,190,.16),transparent 62%),radial-gradient(700px 420px at 0% 100%,rgba(69,115,166,.13),transparent 62%)}
.sv-hero::before{content:"";position:absolute;inset:0;z-index:-1;background-image:radial-gradient(rgba(69,115,166,.2) 1.2px,transparent 1.5px);background-size:24px 24px;
  -webkit-mask-image:linear-gradient(to bottom,#000,transparent 80%);mask-image:linear-gradient(to bottom,#000,transparent 80%)}
.sv-hero .sv-text{animation:svR .9s cubic-bezier(.2,.8,.2,1) backwards}
.sv-vis{position:relative;flex:none;width:48%;max-width:560px;animation:svL .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.sv-vis::before{content:"";position:absolute;inset:-50px;z-index:-1;background:radial-gradient(circle,rgba(37,150,190,.28),transparent 65%);filter:blur(34px)}
.sv-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.sv-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:svSpin 8s linear infinite}
.sv-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#fff}
.sv-tilt{position:relative;padding:28px;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.5);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.sv-tilt img{display:block;width:100%;height:auto;object-fit:contain}
.sv-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.sv-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.sv-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.sv-chipf.c1{left:-34px;bottom:44px;animation:svFloat 5s ease-in-out infinite}
.sv-chipf.c2{right:-24px;top:34px;animation:svFloat 6s -2s ease-in-out infinite}

/* image card */
.sv-img{position:relative;flex:none;width:42%;max-width:480px}
.sv-img::before{content:"";position:absolute;z-index:-1;inset:-18px 18px 18px -18px;border-radius:32px;background:linear-gradient(135deg,#e3f1f8,#f4fafd);border:1px solid var(--line)}
.sv-img::after{content:"";position:absolute;z-index:-1;right:-28px;bottom:-28px;width:96px;height:96px;border-radius:50%;background:linear-gradient(135deg,var(--btn),var(--head));opacity:.2}
.sv-in.rev .sv-img::after{right:auto;left:-28px}
.sv-sec.tint .sv-img::before{background:#fff}
.sv-in.rev .sv-img::before{inset:-18px -18px 18px 18px}
.sv-img img{position:relative;display:block;width:100%;height:auto;object-fit:contain;padding:22px;border-radius:32px;background:#fff;border:1px solid var(--line);
  box-shadow:0 30px 50px -26px rgba(69,115,166,.5);transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-img:hover img{transform:translateY(-8px)}

/* feature cards */
.sv-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:28px;align-items:stretch;max-width:1240px;margin:48px auto 0}
.sv-grid>.rv{display:flex;min-width:0}
.sv-grid>.rv>.sv-card{width:100%;height:auto}
.sv-grid.c3{grid-template-columns:repeat(3,minmax(0,1fr))}
.sv-grid.c2{grid-template-columns:repeat(2,minmax(0,1fr))}
.sv-card{box-sizing:border-box;--mx:50%;--my:50%;--rx:0deg;--ry:0deg;position:relative;overflow:hidden;height:100%;text-align:center;padding:36px 22px 30px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transform:perspective(900px) rotateX(var(--rx)) rotateY(var(--ry));transition:transform .18s ease-out,box-shadow .4s,border-color .4s}
.sv-card:hover{z-index:2;border-color:transparent;box-shadow:0 30px 50px -22px rgba(37,150,190,.7)}
.sv-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.sv-card:hover .sv-glow{opacity:1}
.sv-top{position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.sv-card:hover .sv-top{transform:scaleX(1)}
.sv-icon{position:relative;width:80px;height:80px;margin:0 auto 20px;border-radius:24px;background:var(--tint);display:flex;align-items:center;justify-content:center;
  transition:background .4s,box-shadow .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-icon svg{width:34px;height:34px;fill:none;stroke:var(--head);stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:stroke .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-icon img{width:44px;height:44px;object-fit:contain;transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-card:hover .sv-icon{background:linear-gradient(135deg,var(--head),var(--btn));transform:translateY(-6px);box-shadow:0 10px 22px -8px rgba(37,150,190,.6)}
.sv-card:hover .sv-icon svg{stroke:#fff;transform:scale(1.1)}
.sv-card:hover .sv-icon img{transform:scale(1.1)}
.sv-card h3{position:relative;display:inline-block;margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:19px;letter-spacing:.6px;color:var(--head)}
.sv-card h3::after{content:"";position:absolute;left:0;bottom:-5px;height:2px;width:0;background:var(--btn);transition:width .45s cubic-bezier(.2,.8,.2,1)}
.sv-card:hover h3::after{width:100%}
.sv-card p{position:relative;margin:0;overflow-wrap:break-word}

/* closing call to action */
.sv-cta{position:relative;overflow:hidden;padding:84px 24px;background:linear-gradient(120deg,#35618f,#2596be)}
.sv-cta::before,.sv-cta::after{content:"";position:absolute;border-radius:50%;background:rgba(255,255,255,.08);pointer-events:none}
.sv-cta::before{width:420px;height:420px;left:-140px;top:-200px}
.sv-cta::after{width:320px;height:320px;right:-100px;bottom:-180px}
.sv-cta .sv-center{position:relative;z-index:1}
.sv-cta h2,.sv-cta h2:hover{color:#fff}
.sv .sv-cta p{color:rgba(255,255,255,.92)}
.sv-cta .sv-chip{background:rgba(255,255,255,.14);border-color:rgba(255,255,255,.4);color:#fff;box-shadow:none}
.sv-cta .sv-chip::before{background:#fff}
.sv-cta .sv-line i{background:#fff}.sv-cta .sv-line i:last-child{background:rgba(255,255,255,.6)}
.sv-cta .sv-btn{margin-top:14px;background:#fff;color:var(--head);box-shadow:0 18px 30px -16px rgba(0,0,0,.45)}
.sv-cta .sv-btn::before{background:linear-gradient(90deg,#eef6fa,#cfe8f3)}
.sv-cta .sv-btn:hover{color:var(--head)}

/* scroll progress */
.sv-progress{position:fixed;top:0;left:0;height:3px;width:0;z-index:2000;pointer-events:none;background:linear-gradient(90deg,var(--head,#4573a6),var(--btn,#2596be))}

/* check list */
.sv-list{list-style:none;margin:0 0 8px;padding:0;display:grid;gap:10px}
.sv-list li{display:flex;gap:12px;align-items:flex-start;font-size:14.5px;line-height:1.7;color:var(--text);padding:12px 14px;border-radius:16px;background:#fff;border:1px solid var(--line);
  transition:transform .35s cubic-bezier(.3,1.4,.5,1),box-shadow .35s,border-color .35s}
.sv-list li:hover{transform:translateX(6px);border-color:rgba(37,150,190,.5);box-shadow:0 14px 26px -18px rgba(37,150,190,.7)}
.sv-list li::before{content:"\\2713";flex:none;width:24px;height:24px;margin-top:1px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,var(--head),var(--btn));color:#fff;font-size:13px;font-weight:700}

@keyframes svL{from{opacity:0;transform:translateX(-70px)}}
@keyframes svR{from{opacity:0;transform:translateX(70px)}}
@keyframes svSpin{to{transform:rotate(360deg)}}
@keyframes svFloat{50%{transform:translateY(-12px)}}

@media(max-width:1180px){.sv-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:1000px){.sv-grid.c3{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:960px){
  .sv-hero{padding:120px 18px 60px}
  .sv-in,.sv-in.rev{flex-direction:column;gap:56px}
  .sv-text{max-width:100%}
  .sv-vis,.sv-img{width:100%;max-width:420px}
  .sv-chipf.c1{left:-8px}.sv-chipf.c2{right:-8px}
  .sv-sec{padding:52px 18px}
  .sv-num{font-size:84px;top:-30px}
  .sv-cta{padding:60px 18px}
}
@media(max-width:600px){
  .sv h1,.sv-hero h1{font-size:30px}.sv-sec h2{font-size:28px}
  .sv-grid,.sv-grid.c3,.sv-grid.c2{grid-template-columns:1fr}
}
@media(prefers-reduced-motion:reduce){
  .sv *,.sv *::before,.sv *::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
}
`;

/* ---------- small helpers ---------- */

/* fades a block in once it scrolls into view */
export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={"rv " + className + (show ? " in" : "")} style={{ "--d": delay + "s" }}>
      {children}
    </div>
  );
};

const Lines = () => (
  <div className="sv-line"><i /><i /></div>
);

export const Paras = ({ items = [] }) => items.map((t, i) => <p key={i}>{t}</p>);

export const CheckList = ({ items = [] }) => (
  <ul className="sv-list">
    {items.map((t, i) => <li key={i}>{t}</li>)}
  </ul>
);

/* ---------- page shell ---------- */
const ScrollProgress = () => {
  const ref = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      if (ref.current) ref.current.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + "%";
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div className="sv-progress" ref={ref} />;
};

export const ServiceShell = ({ children }) => (
  <div>
    <ScrollProgress />
    <NavBar />
    <style>{SERVICE_STYLES}</style>
    <div className="sv">{children}</div>
    <Help />
    <ScrollToTopButton />
    <Footer />
  </div>
);

/* plain section wrapper (tint = soft blue band) */
export const Section = ({ tint = false, children, style }) => (
  <div className={"sv-sec" + (tint ? " tint" : "")} style={style}>{children}</div>
);

/* ---------- hero ---------- */
const DEFAULT_BADGES = [
  { label: "Quality", strong: "Delivery", mark: "✓" },
  { label: "Client", strong: "First", mark: "★" },
];

export const Hero = ({
  chip,
  title,
  sub,
  paragraphs = [],
  tags = [],
  cta = "Get Started",
  img,
  alt = "",
  badges = DEFAULT_BADGES,
}) => {
  const history = useHistory();
  const tiltRef = useRef(null);

  // gentle 3D tilt on the hero image
  const handleMove = (e) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div className="sv-hero">
      <div className="sv-in rev">
        <div className="sv-text">
          {chip && <div className="sv-chip">{chip}</div>}
          <h1>{title}</h1>
          <Lines />
          {sub && <h3 className="sv-sub">{sub}</h3>}
          <Paras items={paragraphs} />
          {tags.length > 0 && (
            <div className="sv-tags">
              {tags.map((t) => <span className="sv-tag" key={t}>{t}</span>)}
            </div>
          )}
          <button className="sv-btn primary" onClick={() => history.push("/contact")}>
            {cta} <span>→</span>
          </button>
        </div>

        <div className="sv-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
          <div className="sv-ring" />
          <div className="sv-tilt" ref={tiltRef}>
            <img src={img} alt={alt} />
          </div>
          {badges.slice(0, 2).map((b, i) => (
            <div className={"sv-chipf c" + (i + 1)} key={i}>
              <span className="dot">{b.mark}</span>
              <div>{b.label}<b>{b.strong}</b></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

/* ---------- centered intro block ---------- */
export const Intro = ({ chip, title, sub, paragraphs = [], children }) => (
  <>
    <Reveal className="sv-center">
      {chip && <div className="sv-chip">{chip}</div>}
      <h2>{title}</h2>
      <Lines />
      {sub && <h3 className="sv-sub">{sub}</h3>}
      <Paras items={paragraphs} />
    </Reveal>
    {children}
  </>
);

/* ---------- image + text row ---------- */
export const Split = ({ img, alt = "", reverse = false, chip, title, sub, paragraphs = [], children }) => {
  // "Step 3" / "Service 2" chips get a big outlined numeral behind the text
  const m = chip && String(chip).match(/^(?:Step|Service)\s+(\d+)$/i);
  return (
  <div className={"sv-in" + (reverse ? " rev" : "")}>
    <Reveal className="sv-img">
      <img src={img} alt={alt} />
    </Reveal>
    <Reveal className="sv-text" delay={0.12}>
      {m && <div className="sv-num" aria-hidden="true">{String(m[1]).padStart(2, "0")}</div>}
      {chip && <div className="sv-chip">{chip}</div>}
      <h2>{title}</h2>
      <Lines />
      {sub && <h3 className="sv-sub">{sub}</h3>}
      <Paras items={paragraphs} />
      {children}
    </Reveal>
  </div>
  );
};

/* ---------- feature cards (icon or image per card) ---------- */
const FeatureCard = ({ item }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty("--mx", x + "px");
    el.style.setProperty("--my", y + "px");
    el.style.setProperty("--ry", ((x / r.width - 0.5) * 8).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((0.5 - y / r.height) * 8).toFixed(2) + "deg");
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.setProperty("--rx", "0deg");
    ref.current.style.setProperty("--ry", "0deg");
  };

  return (
    <div className="sv-card" ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave}>
      <div className="sv-top" />
      <div className="sv-glow" />
      <div className="sv-icon">
        {item.img ? (
          <img src={item.img} alt={item.alt || item.title} />
        ) : (
          <svg viewBox="0 0 24 24">{ICONS[item.icon] || ICONS.layers}</svg>
        )}
      </div>
      <h3>{item.title}</h3>
      <p>{item.text}</p>
    </div>
  );
};

/* cols: 4 (default) | 3 | 2 */
export const FeatureGrid = ({ items = [], cols = 4 }) => (
  <div className={"sv-grid" + (cols === 3 ? " c3" : cols === 2 ? " c2" : "")}>
    {items.map((it, i) => (
      <Reveal key={it.title} delay={(i % cols) * 0.1}>
        <FeatureCard item={it} />
      </Reveal>
    ))}
  </div>
);

/* ---------- closing call to action ---------- */
export const Cta = ({ chip = "Let's Talk", title, paragraphs = [], label = "Contact Us" }) => {
  const history = useHistory();
  return (
    <div className="sv-cta">
      <Reveal className="sv-center">
        <div className="sv-chip">{chip}</div>
        <h2>{title}</h2>
        <Lines />
        <Paras items={paragraphs} />
        <button className="sv-btn" onClick={() => history.push("/contact")}>
          {label} <span>→</span>
        </button>
      </Reveal>
    </div>
  );
};